/* Super Tots - dynamic announcement currency (stores-iq, 2026-06-25)
   Converts the USD amount in the announcement bar to the visitor's local
   presentment currency using Shopify.currency.rate. Falls back to USD.
   Defensive: never throws; no regex; leaves text unchanged if data missing. */
(function () {
  function convertDollar(str, rate, active) {
    var idx = str.indexOf('$');
    if (idx === -1) return str;
    var j = idx + 1;
    while (j < str.length && str.charAt(j) === ' ') j++;
    var start = j;
    while (j < str.length) {
      var c = str.charAt(j);
      if ((c >= '0' && c <= '9') || c === '.' || c === ',') { j++; } else { break; }
    }
    if (j === start) return str;
    var amount = parseFloat(str.slice(start, j).split(',').join(''));
    if (isNaN(amount)) return str;
    var val = Math.ceil(amount * rate);
    var formatted;
    try {
      formatted = new Intl.NumberFormat(undefined, { style: 'currency', currency: active, maximumFractionDigits: 0 }).format(val);
    } catch (e) { return str; }
    return str.slice(0, idx) + formatted + str.slice(j);
  }
  function run() {
    try {
      var cur = (window.Shopify && window.Shopify.currency) || {};
      var active = cur.active;
      var rate = parseFloat(cur.rate);
      if (!active) return;
      var nodes = document.querySelectorAll('.announcement-bar__message span');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (!el.hasAttribute('data-cc-base')) el.setAttribute('data-cc-base', el.textContent);
        var base = el.getAttribute('data-cc-base');
        if (el.getAttribute('data-cc-cur') === active) continue;
        if (base.indexOf('$') === -1) { el.setAttribute('data-cc-cur', active); continue; }
        if (active === 'USD' || !rate || isNaN(rate)) {
          el.textContent = base;
          el.setAttribute('data-cc-cur', active);
          continue;
        }
        el.textContent = convertDollar(base, rate, active);
        el.setAttribute('data-cc-cur', active);
      }
    } catch (e) { /* never break the storefront */ }
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 600);
  setTimeout(run, 1500);
})();
